import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  existingAccount: {
    id: 'app.signup.welcome.existing_account',
    description: 'Button label for when a customer already has an account',
    defaultMessage: 'I have an account',
  },
  getStarted: {
    id: 'app.signup.welcome.get_started_variant',
    description: 'The sign-up button variant for \'Get Started\'',
    defaultMessage: 'Get Started',
  },
  title: {
    id: 'app.signup.welcome.title',
    description: 'App title',
    defaultMessage: 'Track staff time and attendance',
  },
  subtitle: {
    id: 'app.signup.welcome.subtitle',
    description: 'App subtitle',
    defaultMessage: 'Using the Tanda Time Clock you can accurately record staff time.',
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_welcome/i18n.js